// eslint-disable-next-line import/no-anonymous-default-export
export default {
  color: {
    backgroundPage: "#fff",
    backgroundNavbar: "#47a3ff9c",
    like: "#47a3ff9c",
    CardColor: "#47a3ff9c",
    CardColorText: "#000",
    colorNavbar: "#000",
    textColor: "#000",
  },

  width: {
    logoWidth: "167px",
  },
  image: {
    logo: "../logo_St.png",
    logoNav: "../logo_St_2.png",
  },
};
